import React from 'react';
import PropTypes from 'prop-types';

import {
  GridItem,
  GridContainer,
} from '../../generic';

import {
  DeviceAdvancedCard,
} from '../components';

const DeviceAdvancedTab = (props) => {
  const { device, canEdit } = props;
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <DeviceAdvancedCard
          device={device}
          canEdit={canEdit}
        />
      </GridItem>
    </GridContainer>
  );
};

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  device: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

DeviceAdvancedTab.propTypes = propTypes;
export default DeviceAdvancedTab;
